import React, { Component } from "react";

export default class Audio extends Component {
  constructor(props) {
    super(props);
    console.log("props", this.props);
    this.state = {
      heading: this.props.heading,
      description: this.props.description,
      audio: this.props.content,
    };
  }

  render() {
    console.log("state", this.state.audio);
    return (
      <div>
        <h2>{this.state.heading}</h2>
        <p>{this.state.description}</p>
        <audio controls src={this.state.audio}>
          Your browser does not support the Audio element
        </audio>
      </div>
    );
  }
}
